import { render, staticRenderFns } from "./propertyNoticeDetail.vue?vue&type=template&id=ef0271d2&scoped=true"
import script from "./propertyNoticeDetail.vue?vue&type=script&lang=js"
export * from "./propertyNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./propertyNoticeDetail.vue?vue&type=style&index=0&id=ef0271d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0271d2",
  null
  
)

export default component.exports